const slugify = (text) =>
  text
    ?.trim()
    .toLowerCase()
    .replace(/\s+/g, "-")               // spaces → hyphen
    .replace(/[^\p{L}\p{N}-]/gu, "");   // keep ALL languages

export default slugify;
